import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';

const qaTagArtistSidebarButtonsMap = {
  [D.QA.BRCS]: D.QA.BSASS,
  [D.QA.BRP]: D.QA.BSATS,
  [D.QA.BRPU]: D.QA.BSATS,
};

// @ts-expect-error TS(7006) FIXME: Parameter 'qaTag' implicitly has an 'any' type.
const qaTagGetter = qaTag => {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return qaTagArtistSidebarButtonsMap[qaTag] || qaTag;
};

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const ArtistSidebarButtons = props => {
  const {
    artistName,
    hasRadio,
    playTopSongs,
    pauseTopSongs,
    isArtistTopSongsPlaying,
    topSongsHaveNoRights,
    playArtistStation,
    shareArtist,
  } = props;

  const disabledButtons = [];
  if (!hasRadio) disabledButtons.push(D.ButtonRowType.CREATE_STATION);
  if (topSongsHaveNoRights) disabledButtons.push(D.ButtonRowType.PLAY);

  return (
    <div className='ArtistSidebarButtons' data-qa={D.QA.BSAB}>
      <D.ButtonRowWithLogger
        // @ts-expect-error TS(2322) FIXME: Type '{ createStationOnClick: any; playOnClick: an... Remove this comment to see the full error message
        createStationOnClick={playArtistStation}
        playOnClick={!isArtistTopSongsPlaying && playTopSongs}
        pauseOnClick={isArtistTopSongsPlaying && pauseTopSongs}
        shareOnClick={shareArtist}
        buttonTextType={D.ButtonTextType.PLAY_TOP_SONGS}
        hiddenButtons={[D.ButtonRowType.MORE]}
        disabledButtons={disabledButtons}
        qaTagGetter={qaTagGetter}
        isSidebar={true}
        entityName={artistName}
      />
    </div>
  );
};

ArtistSidebarButtons.propTypes = {
  hasRadio: PropTypes.bool,
  artistName: PropTypes.string,
  isArtistTopSongsPlaying: PropTypes.bool,
  playTopSongs: PropTypes.func,
  pauseTopSongs: PropTypes.func,
  playArtistStation: PropTypes.func,
  shareArtist: PropTypes.func,
  topSongsHaveNoRights: PropTypes.bool,
};

export default ArtistSidebarButtons;
